import { FC, Fragment, useEffect, useRef, useState } from "react";
import "utils/styles/root.scss";
import "utils/styles/index.scss";
import 'suneditor/dist/css/suneditor.min.css';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigationType, Navigate, Outlet } from "react-router-dom";
import { AdminContainer, AdminWrapper } from "layouts/admin/layout";
import {
	PageAdminLogin, PageAdminHome, PageAdminConfig,
	PageAdminRoleCreate,
	PageAdminRoleUpdate,
	PageAdminRole,
	PageAdminRolePermissionAccessControll,
	PageAdminUser,
	PageAdminUserCreate,
	PageAdminUserUpdate,
	PageAdminPermission,
	PageAdminPermissionCreate,
	PageAdminPermissionUpdate,
	PageAdminPermissionContainer,
	PageAdminUserPermissionAccessControll,

	PageAdminMenu,
	PageAdminMenuCreate,
	PageAdminMenuUpdate,

	PageAdminProfile,
	PageAdminLibrary,
	PageAdminForm,
	PageAdminStatus,
	PageAdminStatusCreate,
	PageAdminStatusUpdate,
	PageAdminWorkflow,
	PageAdminWorkflowCreate,
	PageAdminWorkflowUpdate,

	PageAdminWorkflowStep,
	PageAdminWorkflowStepCreate,
	PageAdminWorkflowStepUpdate,
	PageAdminFormCreate,
	PageAdminFormUpdate,
	PageAdminPage, PageAdminPageCreate, PageAdminPageUpdate, PageAdminPageBuilder,

	PageAdminModule,
	PageAdminModuleCreate,
	PageAdminModuleUpdate,

	PageAdminLayout,
	PageAdminLayoutUpdate,
	PageAdminLayoutCreate,
	PageAdminData,
	PageAdminDataForm,
	PageAdminFormBuilder,
	PageAdminFormStatus,
	PageAdminGroupUser,
	PageAdminGroupUserCreate,
	PageAdminGroupUserUpdate,
	PageAdminGroupUserPermissionAccessControll,
	PageAdminGroupUsers,
	PageAdminFormStep,
	PageAdminGroupFormAccessControll,
	PageAdminRoleFormAccessControll,
	PageAdminUserFormAccessControll,
	PageAdminFormStepConfig,
	PageAdminWorkflowStepProcessFlow,
	PageAdminPageBuilderView_V2,
	PageAdminPageBuilderPreview,
	PageAdminLocaleUpdate,
	PageAdminLocaleCreate,
	PageAdminLocale,
	PageAdminLocaleTranslate,
	PageAdminMenuContainer,
} from "layouts";
import axios from "axios";
import { store } from "store";
import { authLogout } from "store/auth";
import { apiAuthCheck, apiGetConfig, apiLocaleOptions, apiPagePublishPages } from "apis";
import { AppMessage } from "components";
import moment from "moment";
import { CONST_DAY_NAMES, CONST_DAY_NAMES_SHORT, CONST_LOCALE_DEFAULT, CONST_MONTH_NAMES, CONST_MONTH_NAMES_SHORT } from "utils";
import { AppNotFound } from "components";
import DataProvider from "layouts/admin/pages/data/Container";
import FilteredSearch from ".test/Search";
import TestNotify from ".test/notifi";
import useAppSelector from "hooks/useAppSelector";
import useUrl from "hooks/useUrl";
import AppLoading from "components/AppLoading";
import useAppTranslation, { namespaces } from "hooks/useAppTranslation";

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		// fallbackLng: 'vi',
		interpolation: {
			escapeValue: false,
		},
		ns: [],
		defaultNS: 'common',

		resources: {
		},
	});

const App = () => {
	const { token, user } = useAppSelector(state => state.auth);
	const e401 = useRef<boolean>(false);
	axios.defaults.headers["Content-Type"] = "application/json";
	axios.defaults.headers["Authorization"] = token ? `Bearer ${token}` : null;

	axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
	axios.interceptors.response.use(
		(response) => {
			return response;
		},
		async (error) => {
			let response = error.response || {};
			switch (error.response?.status) {
				case 401:
					if (!e401.current) {
						e401.current = true;
						setTimeout(() => {
							e401.current = false;
						}, 3000)
						if (token) {
							AppMessage.error({
								title: "Thông báo!",
								message: "Phiên làm việc đã hết hạn. Vui lòng đăng nhập lại để tiếp tục!",
							});
						}
					}
					store.dispatch(authLogout());
					break;
				case 403:
					AppMessage.error({
						title: "Thông báo!",
						message: "Bạn không có quyền thao tác. Vui lòng liên hệ quản trị viên!",
					});
					break;
				default:
					AppMessage.error({
						title: "Thông báo lỗi",
						message: response?.data?.message,
					});
					break;
			}
			return response;
		}
	);
	const [ready, setReady] = useState<boolean>(false);
	useEffect(() => {
		const int = async () => {
			setReady(false);
			await apiAuthCheck();
			await apiGetConfig();
			await apiPagePublishPages();
			const resLocale = await apiLocaleOptions({});
			if (resLocale.data?.list) {
				const locales = resLocale.data.list;

				locales.map((locale) => {
					const translateI18n = locale.translateI18n as { [key: string]: object };

					namespaces.map(code => {
						i18n.addResourceBundle(locale.code, code, translateI18n?.[code] || {}, true, true);
					})
				})
				await i18n.reloadResources();
			}
			setReady(true)
		}
		int();
	}, [])

	const publishPages = useAppSelector(state => state.page.list.publishPages);
	const locales = useAppSelector(state => state.locale.list.options);

	const { t } = useAppTranslation();
	const { urls, adminPrefix } = useUrl();
	useEffect(() => {
		i18n.changeLanguage(user?.locale);
		moment.updateLocale(user?.locale || CONST_LOCALE_DEFAULT, {
			week: { dow: 1 },
			months: CONST_MONTH_NAMES.map(code => t(code, { ns: "common" })),
			monthsShort: CONST_MONTH_NAMES_SHORT.map(code => t(code, { ns: "common" })),
			weekdays: CONST_DAY_NAMES.map(code => t(code, { ns: "common" })),
			weekdaysShort: CONST_DAY_NAMES_SHORT.map(code => t(code, { ns: "common" })),
		});
	}, [user?.locale, locales])

	if (!ready) {
		return <AppLoading />
	}
	return (
		<Fragment>
			<Router>
				<ScrollRestoration />
				<Routes>
					{/* Test */}
					<Route path=".test" element={<Outlet />}>
						<Route path="search" element={<FilteredSearch />} />
						<Route path="notify" element={<TestNotify />} />
					</Route>
					{/* END Test */}
					<Route path={adminPrefix} element={<Outlet />}>
						<Route path={urls["_URL_LOGIN"]} element={<PageAdminLogin />} />
						<Route path={urls["_URL_PAGE.BUILDER.PREVIEW"]} element={<PageAdminPageBuilderPreview />} />
					</Route>
					<Route path={adminPrefix} element={<AdminContainer />}>
						<Route path="" element={<Navigate to={urls["URL_DASHBOARD"]} replace />} />
						<Route path={urls["_URL_DASHBOARD"]} element={<PageAdminHome />} />
						<Route path={urls["_URL_PROFILE"]} element={<PageAdminProfile />} />
						{/* folder-explorer */}
						<Route path={urls["_URL_LIBRARY"]} element={<AdminWrapper permissionCode="admin.library.all"><PageAdminLibrary /></AdminWrapper>} />
						<Route path={urls["_URL_CONFIG"]} element={<AdminWrapper permissionCode="admin.config.all"><PageAdminConfig /></AdminWrapper>} />

						{/* Ngôn ngữ */}
						<Route path={urls["_URL_LOCALE"]} element={<AdminWrapper permissionCode="admin.locale.all"><PageAdminLocale /></AdminWrapper>} />
						<Route path={urls["_URL_LOCALE.CREATE"]} element={<AdminWrapper permissionCode="admin.locale.create"><PageAdminLocaleCreate /></AdminWrapper>} />
						<Route path={urls["_URL_LOCALE.EDIT"]} element={<AdminWrapper permissionCode="admin.locale.update"><PageAdminLocaleUpdate /></AdminWrapper>} />
						<Route path={urls["_URL_LOCALE.TRANSLATE"]} element={<AdminWrapper permissionCode="admin.locale.translate"><PageAdminLocaleTranslate /></AdminWrapper>} />

						{/* Vai trò */}
						<Route path={urls["_URL_ROLE"]} element={<AdminWrapper permissionCode="admin.role.all"><PageAdminRole /></AdminWrapper>} />
						<Route path={urls["_URL_ROLE.CREATE"]} element={<AdminWrapper permissionCode="admin.role.create"><PageAdminRoleCreate /></AdminWrapper>} />
						<Route path={urls["_URL_ROLE.EDIT"]} element={<AdminWrapper permissionCode="admin.role.update"><PageAdminRoleUpdate /></AdminWrapper>} />
						<Route path={urls["_URL_ROLE.ACCESS_CONTROL.PERMISSION"]} element={<AdminWrapper permissionCode="admin.permission.user_access_control"><PageAdminRolePermissionAccessControll /></AdminWrapper>} />
						<Route path={urls["_URL_ROLE.ACCESS_CONTROL.FORM"]} element={<AdminWrapper permissionCode="admin.form.user_access_control"><PageAdminRoleFormAccessControll /></AdminWrapper>} />

						{/* Người dùng */}
						<Route path={urls["_URL_USER"]} element={<AdminWrapper permissionCode="admin.user.all"><PageAdminUser /></AdminWrapper>} />
						<Route path={urls["_URL_USER.CREATE"]} element={<AdminWrapper permissionCode="admin.user.create"><PageAdminUserCreate /></AdminWrapper>} />
						<Route path={urls["_URL_USER.EDIT"]} element={<AdminWrapper permissionCode="admin.user.update"><PageAdminUserUpdate /></AdminWrapper>} />
						<Route path={urls["_URL_USER.ACCESS_CONTROL.PERMISSION"]} element={<AdminWrapper permissionCode="admin.permission.user_access_control"><PageAdminUserPermissionAccessControll /></AdminWrapper>} />
						<Route path={urls["_URL_USER.ACCESS_CONTROL.FORM"]} element={<AdminWrapper permissionCode="admin.form.user_access_control"><PageAdminUserFormAccessControll /></AdminWrapper>} />

						{/* Nhóm người dùng */}
						<Route path={urls["_URL_GROUP_USER"]} element={<AdminWrapper permissionCode="admin.group_user.all"><PageAdminGroupUser /></AdminWrapper>} />
						<Route path={urls["_URL_GROUP_USER.CREATE"]} element={<AdminWrapper permissionCode="admin.group_user.create"><PageAdminGroupUserCreate /></AdminWrapper>} />
						<Route path={urls["_URL_GROUP_USER.EDIT"]} element={<AdminWrapper permissionCode="admin.group_user.update"><PageAdminGroupUserUpdate /></AdminWrapper>} />
						<Route path={urls["_URL_GROUP_USER.USERS"]} element={<AdminWrapper permissionCode="admin.group_user.update"><PageAdminGroupUsers /></AdminWrapper>} />
						<Route path={urls["_URL_GROUP_USER.ACCESS_CONTROL.PERMISSION"]} element={<AdminWrapper permissionCode="admin.permission.user_access_control"><PageAdminGroupUserPermissionAccessControll /></AdminWrapper>} />
						<Route path={urls["_URL_GROUP_USER.ACCESS_CONTROL.FORM"]} element={<AdminWrapper permissionCode="admin.form.user_access_control"><PageAdminGroupFormAccessControll /></AdminWrapper>} />

						{/* Quyền */}
						<Route path="" element={<AdminWrapper permissionCode="admin.permission.all"><PageAdminPermissionContainer /></AdminWrapper>}>
							<Route path={urls["_URL_PERMISSION"]} element={<AdminWrapper permissionCode="admin.permission.all"><PageAdminPermission /></AdminWrapper>} />
							<Route path={urls["_URL_PERMISSION.CREATE"]} element={<AdminWrapper permissionCode="admin.permission.create"><PageAdminPermissionCreate /></AdminWrapper>} />
							<Route path={urls["_URL_PERMISSION.EDIT"]} element={<AdminWrapper permissionCode="admin.permission.update"><PageAdminPermissionUpdate /></AdminWrapper>} />
						</Route>

						{/* Menu */}
						<Route path="" element={<AdminWrapper permissionCode="admin.menu.all"><PageAdminMenuContainer /></AdminWrapper>}>
							<Route path={urls["_URL_MENU"]} element={<AdminWrapper permissionCode="admin.menu.all"><PageAdminMenu /></AdminWrapper>} />
							<Route path={urls["_URL_MENU.CREATE"]} element={<AdminWrapper permissionCode="admin.menu.create"><PageAdminMenuCreate /></AdminWrapper>} />
							<Route path={urls["_URL_MENU.EDIT"]} element={<AdminWrapper permissionCode="admin.menu.update"><PageAdminMenuUpdate /></AdminWrapper>} />
						</Route>

						{/* Trạng thái */}
						<Route path={urls["_URL_STATUS"]} element={<AdminWrapper permissionCode="admin.status.all"><PageAdminStatus /></AdminWrapper>} />
						<Route path={urls["_URL_STATUS.CREATE"]} element={<AdminWrapper permissionCode="admin.status.create"><PageAdminStatusCreate /></AdminWrapper>} />
						<Route path={urls["_URL_STATUS.EDIT"]} element={<AdminWrapper permissionCode="admin.status.update"><PageAdminStatusUpdate /></AdminWrapper>} />

						{/* Quy trình */}
						<Route path={urls["_URL_WORKFLOW"]} element={<AdminWrapper permissionCode="admin.workflow.all"><PageAdminWorkflow /></AdminWrapper>} />
						<Route path={urls["_URL_WORKFLOW.CREATE"]} element={<AdminWrapper permissionCode="admin.workflow.create"><PageAdminWorkflowCreate /></AdminWrapper>} />
						<Route path={urls["_URL_WORKFLOW.EDIT"]} element={<AdminWrapper permissionCode="admin.workflow.update"><PageAdminWorkflowUpdate /></AdminWrapper>} />
						<Route path={urls["_URL_WORKFLOW.PROCESS_FLOW"]} element={<AdminWrapper permissionCode="admin.workflow.update"><PageAdminWorkflowStepProcessFlow /></AdminWrapper>} />
						<Route path={urls["_URL_WORKFLOW.STEP"]} element={<AdminWrapper permissionCode="admin.workflow.update"><PageAdminWorkflowStep /></AdminWrapper>} />
						<Route path={urls["_URL_WORKFLOW.STEP.CREATE"]} element={<AdminWrapper permissionCode="admin.workflow.update"><PageAdminWorkflowStepCreate /></AdminWrapper>} />
						<Route path={urls["_URL_WORKFLOW.STEP.EDIT"]} element={<AdminWrapper permissionCode="admin.workflow.update"><PageAdminWorkflowStepUpdate /></AdminWrapper>} />

						{/* Form */}
						<Route path={urls["_URL_FORM"]} element={<AdminWrapper permissionCode="admin.form.all"><PageAdminForm /></AdminWrapper>} />
						<Route path={urls["_URL_FORM.CREATE"]} element={<AdminWrapper permissionCode="admin.form.create"><PageAdminFormCreate /></AdminWrapper>} />
						<Route path={urls["_URL_FORM.EDIT"]} element={<AdminWrapper permissionCode="admin.form.update"><PageAdminFormUpdate /></AdminWrapper>} />
						<Route path={urls["_URL_FORM.BUILDER"]} element={<AdminWrapper permissionCode="admin.form.build"><PageAdminFormBuilder /></AdminWrapper>} />
						<Route path={urls["_URL_FORM.STATUS"]} element={<AdminWrapper permissionCode="admin.form.update"><PageAdminFormStatus /></AdminWrapper>} />
						<Route path={urls["_URL_FORM.STEP"]} element={<AdminWrapper permissionCode="admin.form.update"><PageAdminFormStep /></AdminWrapper>} />
						<Route path={urls["_URL_FORM.STEP.CONFIG"]} element={<AdminWrapper permissionCode="admin.form.update"><PageAdminFormStepConfig /></AdminWrapper>} />

						<Route path="" element={<DataProvider />}>
							<Route path="data/:formCode.html" element={<PageAdminData />} />
							<Route path="data/:formCode/:stepName/:stepId.html" element={<PageAdminDataForm />} />
							<Route path="data/:formCode/:stepName/:stepId/:id.html" element={<PageAdminDataForm />} />
						</Route>

						{/* Trang */}
						<Route path={urls["_URL_PAGE"]} element={<AdminWrapper permissionCode="admin.page.all"><PageAdminPage /></AdminWrapper>} />
						<Route path={urls["_URL_PAGE.CREATE"]} element={<AdminWrapper permissionCode="admin.page.create"><PageAdminPageCreate /></AdminWrapper>} />
						<Route path={urls["_URL_PAGE.EDIT"]} element={<AdminWrapper permissionCode="admin.page.update"><PageAdminPageUpdate /></AdminWrapper>} />
						<Route path="page/builder/:id.html" element={<AdminWrapper permissionCode="admin.page.build"><PageAdminPageBuilder /></AdminWrapper>} />

						{/* Module */}
						<Route path={urls["_URL_MODULE"]} element={<AdminWrapper permissionCode="admin.module.all"><PageAdminModule /></AdminWrapper>} />
						<Route path={urls["_URL_MODULE.CREATE"]} element={<AdminWrapper permissionCode="admin.module.create"><PageAdminModuleCreate /></AdminWrapper>} />
						<Route path={urls["_URL_MODULE.EDIT"]} element={<AdminWrapper permissionCode="admin.module.update"><PageAdminModuleUpdate /></AdminWrapper>} />

						{/* Layout */}
						<Route path={urls["_URL_LAYOUT"]} element={<AdminWrapper permissionCode="admin.layout.all"><PageAdminLayout /></AdminWrapper>} />
						<Route path={urls["_URL_LAYOUT.CREATE"]} element={<AdminWrapper permissionCode="admin.layout.create"><PageAdminLayoutCreate /></AdminWrapper>} />
						<Route path={urls["_URL_LAYOUT.EDIT"]} element={<AdminWrapper permissionCode="admin.layout.update"><PageAdminLayoutUpdate /></AdminWrapper>} />

						<Route path="*" element={<AppNotFound homeUrl={adminPrefix} />} />
					</Route>

					{publishPages.map(page => <Route path={page.url} element={locales.length > 0 ? <RedirectToDefaultLocale /> : <PageAdminPageBuilderView_V2 pageId={page.id} />} />)}
					{locales.length > 0 && publishPages.map(page => <Route path={`/:locale${page.url}`} element={<PageAdminPageBuilderView_V2 pageId={page.id} />} />)}
					<Route path="*" element={<AppNotFound homeUrl="/" loading={!ready} />} />
				</Routes>
			</Router>

		</Fragment>

	);
};
export default App;

const RedirectToDefaultLocale = () => {
	const location = useLocation();
	return <Navigate to={{ ...location, pathname: `/${CONST_LOCALE_DEFAULT}${location.pathname}` }} replace />;
}

const scrollPositions: Record<string, number> = {};

interface ScrollRestorationProps {
	// scrollRef: React.RefObject<HTMLDivElement | null>;
}
const ScrollRestoration: FC<ScrollRestorationProps> = ({ }) => {
	const location = useLocation();
	const navigationType = useNavigationType();

	useEffect(() => {
		if (navigationType === "POP") {
			// Back/Forward: khôi phục scroll
			const pos = scrollPositions[location.key];
			window.scrollTo(0, pos || 0);
		} else {
			// Push/Replace: luôn về đầu
			window.scrollTo(0, 0);
		}

		return () => {
			// Lưu lại scroll position khi rời khỏi trang
			scrollPositions[location.key] = window.scrollY;
		};
	}, [location, navigationType]);

	return null;
}